module.exports = __webpack_public_path__ + "fe4ebca94674a1109d5d85e3536a16b5.svg";